// @ts-nocheck
import wixFormsConstants from '../constants';
import * as wixFormsUtils from '../utils';
import addPanelDataConsts from '@/addPanelDataConsts';

const title = 'add_section_label_donationsforms';
const presetTitle = 'add_section_label_donationsforms_preset';
const tooltipTitle = 'add_section_label_contactforms_tooltip_title';
const helpText = 'add_section_label_donationsforms_tooltip_description';

const getDonationsSection = (editorAPI) => ({
  donationsSection: {
    type: addPanelDataConsts.SECTIONS_TYPES.PRESET,
    hide: false,
    title,
    topTitle: title,
    tooltipTitle,
    automationId: 'add-panel-section-donationsforms',
    sectionName: 'donationsSection',
    appDefinitionId: wixFormsConstants.FORM_BUILDER_APP_ID,
    showSectionHeader: true,
    subNavigationHide: false,
    presetTitle,
    subNavigationTitle: title,
    additionalBehaviours: {
      labelMode: 'none',
      infoIcon: 'none',
      hoverImageAction: 'scale',
      iconEnabledForComps: {},
    },
    props: {
      image:
        'addPanelData/sections/formsDonationsSection_en/formsDonationsSection_en.v2.png',
      imageStyle: wixFormsConstants.imageStyle,
      imageHover: null,
      items: [
        {
          id: 'Donations_Forms_1',
          onDrop: wixFormsUtils.onDrop(
            editorAPI,
            wixFormsConstants.FormPreset.DONATIONS03,
          ),
          onClick: wixFormsUtils.onClick(
            editorAPI,
            wixFormsConstants.FormPreset.DONATIONS03,
          ),
          structure: wixFormsUtils.getFormWidget({
            layout: {
              width: 197,
              height: 169,
              x: 20,
              y: 412,
              scale: 1.0,
              rotationInDegrees: 0.0,
              fixedPosition: false,
            },
          }),
          preset: { rect: { width: 162, height: 236, x: 0, y: 0 }, tags: null },
        },
        {
          id: 'Donations_Forms_2',
          onDrop: wixFormsUtils.onDrop(
            editorAPI,
            wixFormsConstants.FormPreset.DONATIONS04,
          ),
          onClick: wixFormsUtils.onClick(
            editorAPI,
            wixFormsConstants.FormPreset.DONATIONS04,
          ),
          structure: wixFormsUtils.getFormWidget({
            layout: {
              width: 515,
              height: 742,
              x: 20,
              y: 412,
              scale: 1.0,
              rotationInDegrees: 0.0,
              fixedPosition: false,
            },
          }),
          preset: {
            rect: { width: 162, height: 236, x: 162, y: 0 },
            tags: null,
          },
        },
      ],
      compTypes: [wixFormsConstants.componentType],
    },
    help: {
      hide: false,
      text: helpText,
    },
  },
});

export default (editorAPI) => getDonationsSection(editorAPI);
